/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ArchiveCustomColumnRequestDto,
  ArchiveCustomColumnResponseDto,
  CustomColumnArchivePrecheckResponseDto,
  CustomColumnDefinitionDto,
  UpdateCustomColumnDefinitionsDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns the ordered list of custom columns configured for the partner. Each definition becomes a column in the Schedule editor and addresses a key on `work_orders.metadata`. Empty when the partner hasn't been configured yet.
 * @summary List the partner's custom column definitions
 */
export type customColumnsControllerListDefinitionsResponse200 = {
  data: CustomColumnDefinitionDto[]
  status: 200
}

export type customColumnsControllerListDefinitionsResponse401 = {
  data: void
  status: 401
}

export type customColumnsControllerListDefinitionsResponse403 = {
  data: void
  status: 403
}
    
export type customColumnsControllerListDefinitionsResponseSuccess = (customColumnsControllerListDefinitionsResponse200) & {
  headers: Headers;
};
export type customColumnsControllerListDefinitionsResponseError = (customColumnsControllerListDefinitionsResponse401 | customColumnsControllerListDefinitionsResponse403) & {
  headers: Headers;
};

export type customColumnsControllerListDefinitionsResponse = (customColumnsControllerListDefinitionsResponseSuccess | customColumnsControllerListDefinitionsResponseError)

export const getCustomColumnsControllerListDefinitionsUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/custom-columns`
}

export const customColumnsControllerListDefinitions = async (partnerId: string, options?: RequestInit): Promise<customColumnsControllerListDefinitionsResponse> => {
  
  return customFetch<customColumnsControllerListDefinitionsResponse>(getCustomColumnsControllerListDefinitionsUrl(partnerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCustomColumnsControllerListDefinitionsQueryKey = (partnerId?: string,) => {
    return [
    `/partners/${partnerId}/custom-columns`
    ] as const;
    }

    
export const getCustomColumnsControllerListDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomColumnsControllerListDefinitionsQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>> = ({ signal }) => customColumnsControllerListDefinitions(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CustomColumnsControllerListDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>>
export type CustomColumnsControllerListDefinitionsQueryError = void


export function useCustomColumnsControllerListDefinitions<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>,
          TError,
          Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerListDefinitions<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>,
          TError,
          Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerListDefinitions<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List the partner's custom column definitions
 */

export function useCustomColumnsControllerListDefinitions<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCustomColumnsControllerListDefinitionsQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List the partner's custom column definitions
 */
export const prefetchCustomColumnsControllerListDefinitionsQuery = async <TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomColumnsControllerListDefinitionsQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getCustomColumnsControllerListDefinitionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomColumnsControllerListDefinitionsQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>> = ({ signal }) => customColumnsControllerListDefinitions(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CustomColumnsControllerListDefinitionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>>
export type CustomColumnsControllerListDefinitionsSuspenseQueryError = void


export function useCustomColumnsControllerListDefinitionsSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerListDefinitionsSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerListDefinitionsSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List the partner's custom column definitions
 */

export function useCustomColumnsControllerListDefinitionsSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerListDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCustomColumnsControllerListDefinitionsSuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Replaces the partner's custom column definitions atomically with the supplied list. Existing values in `work_orders.metadata` are not touched: removing a definition orphans the key (re-adding the same key recovers it). Duplicate `metadata_key` values within the request are rejected with 400.
 * @summary Replace the partner's custom column definitions
 */
export type customColumnsControllerReplaceDefinitionsResponse200 = {
  data: CustomColumnDefinitionDto[]
  status: 200
}

export type customColumnsControllerReplaceDefinitionsResponse400 = {
  data: void
  status: 400
}

export type customColumnsControllerReplaceDefinitionsResponse401 = {
  data: void
  status: 401
}

export type customColumnsControllerReplaceDefinitionsResponse403 = {
  data: void
  status: 403
}
    
export type customColumnsControllerReplaceDefinitionsResponseSuccess = (customColumnsControllerReplaceDefinitionsResponse200) & {
  headers: Headers;
};
export type customColumnsControllerReplaceDefinitionsResponseError = (customColumnsControllerReplaceDefinitionsResponse400 | customColumnsControllerReplaceDefinitionsResponse401 | customColumnsControllerReplaceDefinitionsResponse403) & {
  headers: Headers;
};

export type customColumnsControllerReplaceDefinitionsResponse = (customColumnsControllerReplaceDefinitionsResponseSuccess | customColumnsControllerReplaceDefinitionsResponseError)

export const getCustomColumnsControllerReplaceDefinitionsUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/custom-columns`
}

export const customColumnsControllerReplaceDefinitions = async (partnerId: string,
    updateCustomColumnDefinitionsDto: UpdateCustomColumnDefinitionsDto, options?: RequestInit): Promise<customColumnsControllerReplaceDefinitionsResponse> => {
  
  return customFetch<customColumnsControllerReplaceDefinitionsResponse>(getCustomColumnsControllerReplaceDefinitionsUrl(partnerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCustomColumnDefinitionsDto,)
  }
);}




export const getCustomColumnsControllerReplaceDefinitionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerReplaceDefinitions>>, TError,{partnerId: string;data: UpdateCustomColumnDefinitionsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerReplaceDefinitions>>, TError,{partnerId: string;data: UpdateCustomColumnDefinitionsDto}, TContext> => {

const mutationKey = ['customColumnsControllerReplaceDefinitions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customColumnsControllerReplaceDefinitions>>, {partnerId: string;data: UpdateCustomColumnDefinitionsDto}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  customColumnsControllerReplaceDefinitions(partnerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomColumnsControllerReplaceDefinitionsMutationResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerReplaceDefinitions>>>
    export type CustomColumnsControllerReplaceDefinitionsMutationBody = UpdateCustomColumnDefinitionsDto
    export type CustomColumnsControllerReplaceDefinitionsMutationError = void

    /**
 * @summary Replace the partner's custom column definitions
 */
export const useCustomColumnsControllerReplaceDefinitions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerReplaceDefinitions>>, TError,{partnerId: string;data: UpdateCustomColumnDefinitionsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customColumnsControllerReplaceDefinitions>>,
        TError,
        {partnerId: string;data: UpdateCustomColumnDefinitionsDto},
        TContext
      > => {

      const mutationOptions = getCustomColumnsControllerReplaceDefinitionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns per-status counts (draft / scheduled / in_progress / completed) of work orders that hold a value for this column's metadata_key, plus which confirmation modal to show: `standard` when no In Progress work orders use it (archive hides it immediately, includes the zero-usage case) or `blocked` when In Progress work orders exist (archive is queued and the column auto-hides once they complete). Custom columns never affect the product code, so there is no `partial` variant.
 * @summary Pre-check how many work orders use a custom column before archiving
 */
export type customColumnsControllerArchivePrecheckResponse200 = {
  data: CustomColumnArchivePrecheckResponseDto
  status: 200
}

export type customColumnsControllerArchivePrecheckResponse401 = {
  data: void
  status: 401
}

export type customColumnsControllerArchivePrecheckResponse403 = {
  data: void
  status: 403
}

export type customColumnsControllerArchivePrecheckResponse404 = {
  data: void
  status: 404
}
    
export type customColumnsControllerArchivePrecheckResponseSuccess = (customColumnsControllerArchivePrecheckResponse200) & {
  headers: Headers;
};
export type customColumnsControllerArchivePrecheckResponseError = (customColumnsControllerArchivePrecheckResponse401 | customColumnsControllerArchivePrecheckResponse403 | customColumnsControllerArchivePrecheckResponse404) & {
  headers: Headers;
};

export type customColumnsControllerArchivePrecheckResponse = (customColumnsControllerArchivePrecheckResponseSuccess | customColumnsControllerArchivePrecheckResponseError)

export const getCustomColumnsControllerArchivePrecheckUrl = (partnerId: string,
    definitionId: string,) => {


  

  return `/partners/${partnerId}/custom-columns/${definitionId}/archive-precheck`
}

export const customColumnsControllerArchivePrecheck = async (partnerId: string,
    definitionId: string, options?: RequestInit): Promise<customColumnsControllerArchivePrecheckResponse> => {
  
  return customFetch<customColumnsControllerArchivePrecheckResponse>(getCustomColumnsControllerArchivePrecheckUrl(partnerId,definitionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCustomColumnsControllerArchivePrecheckQueryKey = (partnerId?: string,
    definitionId?: string,) => {
    return [
    `/partners/${partnerId}/custom-columns/${definitionId}/archive-precheck`
    ] as const;
    }

    
export const getCustomColumnsControllerArchivePrecheckQueryOptions = <TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(partnerId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomColumnsControllerArchivePrecheckQueryKey(partnerId,definitionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>> = ({ signal }) => customColumnsControllerArchivePrecheck(partnerId,definitionId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId && definitionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CustomColumnsControllerArchivePrecheckQueryResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>>
export type CustomColumnsControllerArchivePrecheckQueryError = void


export function useCustomColumnsControllerArchivePrecheck<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>,
          TError,
          Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerArchivePrecheck<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>,
          TError,
          Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerArchivePrecheck<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Pre-check how many work orders use a custom column before archiving
 */

export function useCustomColumnsControllerArchivePrecheck<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCustomColumnsControllerArchivePrecheckQueryOptions(partnerId,definitionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Pre-check how many work orders use a custom column before archiving
 */
export const prefetchCustomColumnsControllerArchivePrecheckQuery = async <TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomColumnsControllerArchivePrecheckQueryOptions(partnerId,definitionId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getCustomColumnsControllerArchivePrecheckSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(partnerId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomColumnsControllerArchivePrecheckQueryKey(partnerId,definitionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>> = ({ signal }) => customColumnsControllerArchivePrecheck(partnerId,definitionId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CustomColumnsControllerArchivePrecheckSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>>
export type CustomColumnsControllerArchivePrecheckSuspenseQueryError = void


export function useCustomColumnsControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCustomColumnsControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Pre-check how many work orders use a custom column before archiving
 */

export function useCustomColumnsControllerArchivePrecheckSuspense<TData = Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError = void>(
 partnerId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customColumnsControllerArchivePrecheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCustomColumnsControllerArchivePrecheckSuspenseQueryOptions(partnerId,definitionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Archives the whole column in one step (all column types). Existing work-order values for its metadata_key are retained but no longer shown for new entries. If any In Progress work order still holds a value, the archive is queued (`mode: archive_from_future`) and the column stays visible/editable until the last one completes, then auto-hides; otherwise it hides immediately. Returns the outcome (`hidden` or `queued`). Already-archived columns are rejected with 400.
 * @summary Archive a custom column
 */
export type customColumnsControllerArchiveDefinitionResponse200 = {
  data: ArchiveCustomColumnResponseDto
  status: 200
}

export type customColumnsControllerArchiveDefinitionResponse400 = {
  data: void
  status: 400
}

export type customColumnsControllerArchiveDefinitionResponse401 = {
  data: void
  status: 401
}

export type customColumnsControllerArchiveDefinitionResponse403 = {
  data: void
  status: 403
}

export type customColumnsControllerArchiveDefinitionResponse404 = {
  data: void
  status: 404
}
    
export type customColumnsControllerArchiveDefinitionResponseSuccess = (customColumnsControllerArchiveDefinitionResponse200) & {
  headers: Headers;
};
export type customColumnsControllerArchiveDefinitionResponseError = (customColumnsControllerArchiveDefinitionResponse400 | customColumnsControllerArchiveDefinitionResponse401 | customColumnsControllerArchiveDefinitionResponse403 | customColumnsControllerArchiveDefinitionResponse404) & {
  headers: Headers;
};

export type customColumnsControllerArchiveDefinitionResponse = (customColumnsControllerArchiveDefinitionResponseSuccess | customColumnsControllerArchiveDefinitionResponseError)

export const getCustomColumnsControllerArchiveDefinitionUrl = (partnerId: string,
    definitionId: string,) => {


  

  return `/partners/${partnerId}/custom-columns/${definitionId}/archive`
}

export const customColumnsControllerArchiveDefinition = async (partnerId: string,
    definitionId: string,
    archiveCustomColumnRequestDto: ArchiveCustomColumnRequestDto, options?: RequestInit): Promise<customColumnsControllerArchiveDefinitionResponse> => {
  
  return customFetch<customColumnsControllerArchiveDefinitionResponse>(getCustomColumnsControllerArchiveDefinitionUrl(partnerId,definitionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      archiveCustomColumnRequestDto,)
  }
);}




export const getCustomColumnsControllerArchiveDefinitionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerArchiveDefinition>>, TError,{partnerId: string;definitionId: string;data: ArchiveCustomColumnRequestDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerArchiveDefinition>>, TError,{partnerId: string;definitionId: string;data: ArchiveCustomColumnRequestDto}, TContext> => {

const mutationKey = ['customColumnsControllerArchiveDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customColumnsControllerArchiveDefinition>>, {partnerId: string;definitionId: string;data: ArchiveCustomColumnRequestDto}> = (props) => {
          const {partnerId,definitionId,data} = props ?? {};

          return  customColumnsControllerArchiveDefinition(partnerId,definitionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomColumnsControllerArchiveDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerArchiveDefinition>>>
    export type CustomColumnsControllerArchiveDefinitionMutationBody = ArchiveCustomColumnRequestDto
    export type CustomColumnsControllerArchiveDefinitionMutationError = void

    /**
 * @summary Archive a custom column
 */
export const useCustomColumnsControllerArchiveDefinition = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerArchiveDefinition>>, TError,{partnerId: string;definitionId: string;data: ArchiveCustomColumnRequestDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customColumnsControllerArchiveDefinition>>,
        TError,
        {partnerId: string;definitionId: string;data: ArchiveCustomColumnRequestDto},
        TContext
      > => {

      const mutationOptions = getCustomColumnsControllerArchiveDefinitionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reactivates an archived definition so it becomes editable again. Fails with 409 when an active column already uses the same `metadata_key` — rename or remove that column first. The column's existing work-order values are unaffected.
 * @summary Restore an archived custom column
 */
export type customColumnsControllerRestoreDefinitionResponse200 = {
  data: CustomColumnDefinitionDto[]
  status: 200
}

export type customColumnsControllerRestoreDefinitionResponse400 = {
  data: void
  status: 400
}

export type customColumnsControllerRestoreDefinitionResponse401 = {
  data: void
  status: 401
}

export type customColumnsControllerRestoreDefinitionResponse403 = {
  data: void
  status: 403
}

export type customColumnsControllerRestoreDefinitionResponse404 = {
  data: void
  status: 404
}

export type customColumnsControllerRestoreDefinitionResponse409 = {
  data: void
  status: 409
}
    
export type customColumnsControllerRestoreDefinitionResponseSuccess = (customColumnsControllerRestoreDefinitionResponse200) & {
  headers: Headers;
};
export type customColumnsControllerRestoreDefinitionResponseError = (customColumnsControllerRestoreDefinitionResponse400 | customColumnsControllerRestoreDefinitionResponse401 | customColumnsControllerRestoreDefinitionResponse403 | customColumnsControllerRestoreDefinitionResponse404 | customColumnsControllerRestoreDefinitionResponse409) & {
  headers: Headers;
};

export type customColumnsControllerRestoreDefinitionResponse = (customColumnsControllerRestoreDefinitionResponseSuccess | customColumnsControllerRestoreDefinitionResponseError)

export const getCustomColumnsControllerRestoreDefinitionUrl = (partnerId: string,
    definitionId: string,) => {


  

  return `/partners/${partnerId}/custom-columns/${definitionId}/restore`
}

export const customColumnsControllerRestoreDefinition = async (partnerId: string,
    definitionId: string, options?: RequestInit): Promise<customColumnsControllerRestoreDefinitionResponse> => {
  
  return customFetch<customColumnsControllerRestoreDefinitionResponse>(getCustomColumnsControllerRestoreDefinitionUrl(partnerId,definitionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getCustomColumnsControllerRestoreDefinitionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerRestoreDefinition>>, TError,{partnerId: string;definitionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerRestoreDefinition>>, TError,{partnerId: string;definitionId: string}, TContext> => {

const mutationKey = ['customColumnsControllerRestoreDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customColumnsControllerRestoreDefinition>>, {partnerId: string;definitionId: string}> = (props) => {
          const {partnerId,definitionId} = props ?? {};

          return  customColumnsControllerRestoreDefinition(partnerId,definitionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomColumnsControllerRestoreDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerRestoreDefinition>>>
    
    export type CustomColumnsControllerRestoreDefinitionMutationError = void

    /**
 * @summary Restore an archived custom column
 */
export const useCustomColumnsControllerRestoreDefinition = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerRestoreDefinition>>, TError,{partnerId: string;definitionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customColumnsControllerRestoreDefinition>>,
        TError,
        {partnerId: string;definitionId: string},
        TContext
      > => {

      const mutationOptions = getCustomColumnsControllerRestoreDefinitionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Hard-deletes an archived definition. Active columns cannot be deleted here (400) — remove them via the replace (PUT) flow, which archives them when still in use. Existing values in `work_orders.metadata` are not touched.
 * @summary Permanently delete an archived custom column
 */
export type customColumnsControllerDeleteDefinitionResponse200 = {
  data: CustomColumnDefinitionDto[]
  status: 200
}

export type customColumnsControllerDeleteDefinitionResponse400 = {
  data: void
  status: 400
}

export type customColumnsControllerDeleteDefinitionResponse401 = {
  data: void
  status: 401
}

export type customColumnsControllerDeleteDefinitionResponse403 = {
  data: void
  status: 403
}

export type customColumnsControllerDeleteDefinitionResponse404 = {
  data: void
  status: 404
}
    
export type customColumnsControllerDeleteDefinitionResponseSuccess = (customColumnsControllerDeleteDefinitionResponse200) & {
  headers: Headers;
};
export type customColumnsControllerDeleteDefinitionResponseError = (customColumnsControllerDeleteDefinitionResponse400 | customColumnsControllerDeleteDefinitionResponse401 | customColumnsControllerDeleteDefinitionResponse403 | customColumnsControllerDeleteDefinitionResponse404) & {
  headers: Headers;
};

export type customColumnsControllerDeleteDefinitionResponse = (customColumnsControllerDeleteDefinitionResponseSuccess | customColumnsControllerDeleteDefinitionResponseError)

export const getCustomColumnsControllerDeleteDefinitionUrl = (partnerId: string,
    definitionId: string,) => {


  

  return `/partners/${partnerId}/custom-columns/${definitionId}`
}

export const customColumnsControllerDeleteDefinition = async (partnerId: string,
    definitionId: string, options?: RequestInit): Promise<customColumnsControllerDeleteDefinitionResponse> => {
  
  return customFetch<customColumnsControllerDeleteDefinitionResponse>(getCustomColumnsControllerDeleteDefinitionUrl(partnerId,definitionId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getCustomColumnsControllerDeleteDefinitionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerDeleteDefinition>>, TError,{partnerId: string;definitionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerDeleteDefinition>>, TError,{partnerId: string;definitionId: string}, TContext> => {

const mutationKey = ['customColumnsControllerDeleteDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customColumnsControllerDeleteDefinition>>, {partnerId: string;definitionId: string}> = (props) => {
          const {partnerId,definitionId} = props ?? {};

          return  customColumnsControllerDeleteDefinition(partnerId,definitionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomColumnsControllerDeleteDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof customColumnsControllerDeleteDefinition>>>
    
    export type CustomColumnsControllerDeleteDefinitionMutationError = void

    /**
 * @summary Permanently delete an archived custom column
 */
export const useCustomColumnsControllerDeleteDefinition = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customColumnsControllerDeleteDefinition>>, TError,{partnerId: string;definitionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customColumnsControllerDeleteDefinition>>,
        TError,
        {partnerId: string;definitionId: string},
        TContext
      > => {

      const mutationOptions = getCustomColumnsControllerDeleteDefinitionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    